
document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".product-carousel__slides");
  const prevButton = document.querySelector(".product-carousel__prev-arrow");
  const nextButton = document.querySelector(".product-carousel__next-arrow");
  var indicators = document.querySelectorAll('.slide-indicator');
  
  let currentSlideIndex = 0;// Variable to track the current slide index
  let isProgrammaticScroll = false;// Flag to indicate if the scroll was initiated via code and not user
  let scrollTimeout;// Timeout ID for resetting the programmatic scroll flag

  if (document.querySelectorAll(".product-carousel__slide").length >= 2) {
    slider.addEventListener("scroll", function(event) {
        // Check if the scroll was initiated programmatically
        if (!isProgrammaticScroll) {
            var newSlideIndex = Math.round(slider.scrollLeft / calculateScrollAmount());

            if (newSlideIndex !== currentSlideIndex) {
              currentSlideIndex = newSlideIndex;
              updateIndicators(currentSlideIndex);
            }
        }
        
          // Clear any existing scrollTimeout
          clearTimeout(scrollTimeout);

          // Set a timeout to reset the flag after a short delay
          scrollTimeout = setTimeout(function() {
              isProgrammaticScroll = false;
          }, 50); // Adjust the delay as needed
    });

    prevButton.addEventListener("click", () => {
      isProgrammaticScroll = true;
      if (currentSlideIndex > 0) {
        currentSlideIndex--;
      } else {//if first slide, go to last
        currentSlideIndex = indicators.length - 1;
      }
      slider.scrollLeft = currentSlideIndex * calculateScrollAmount();
      updateIndicators();
    });

    nextButton.addEventListener("click", () => {
      isProgrammaticScroll = true;
      if (currentSlideIndex < indicators.length - 1) {
        currentSlideIndex++;
      } else {// If last slide, go to first
        currentSlideIndex = 0;
      }
      slider.scrollLeft = currentSlideIndex * calculateScrollAmount();
      updateIndicators();
    });
  }

  function updateIndicators() {
    indicators.forEach(function(indicator, index) {
      if (index == currentSlideIndex) {
        indicator.classList.add('is-selected');
      } else if (indicator.classList.contains('is-selected')) {
        indicator.classList.remove('is-selected');
      }
    });
  }
  
  // Function to calculate scrollAmount based on the new dimensions of the slider
  function calculateScrollAmount() {
    return slider.scrollWidth / indicators.length;
  }
});
